import { SVGAttributes } from 'react'

const CheckIcon = ({ className, fill = '#878A93', ...props }: SVGAttributes<SVGElement>) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M10.3945 3.16419L4.63476 9.38595C4.60133 9.42211 4.56163 9.45079 4.51792 9.47036C4.47422 9.48993 4.42738 9.5 4.38007 9.5C4.33276 9.5 4.28592 9.48993 4.24222 9.47036C4.19852 9.45079 4.15882 9.42211 4.12538 9.38595L1.6055 6.66393C1.53795 6.59097 1.5 6.492 1.5 6.38882C1.5 6.28563 1.53795 6.18666 1.6055 6.1137C1.67304 6.04073 1.76466 5.99974 1.86018 5.99974C1.95571 5.99974 2.04733 6.04073 2.11487 6.1137L4.38007 8.56108L9.88513 2.61396C9.95267 2.54099 10.0443 2.5 10.1398 2.5C10.2353 2.5 10.327 2.54099 10.3945 2.61396C10.4621 2.68692 10.5 2.78589 10.5 2.88908C10.5 2.99227 10.4621 3.09123 10.3945 3.16419Z"
        fill={fill}
      />
    </svg>
  )
}

export default CheckIcon
